/* import __COLOCATED_TEMPLATE__ from './whatsapp-restricted-replies-banner.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type LogService from 'embercom/services/log-service';
import type Session from 'embercom/services/session';
import { action } from '@ember/object';
import type Conversation from 'embercom/objects/inbox/conversation';
import type { NewConversation } from 'embercom/objects/inbox/conversation';

interface Signature {
  Args: {
    onButtonClick: () => void;
    heading: string;
    body: string;
    conversation?: Conversation | NewConversation;
  };
}

export default class WhatsappRestrictedRepliesBanner extends Component<Signature> {
  @service declare logService: LogService;
  @service declare session: Session;

  @action
  logBannerDisplay() {
    let conversation = this.args.conversation;
    if (!conversation) {
      return;
    }

    // Only log for actual conversations, not new conversations
    if (!conversation.id) {
      return;
    }

    // Check if session/workspace are available
    if (!this.session.isWorkspaceLoaded) {
      return;
    }

    if (!this.session.isTeammateLoaded) {
      return;
    }

    // Gate logging behind feature flag
    let isLogWhatsappMessagesEnabled = this.session.workspace.isFeatureEnabled(
      'team-channels-log-whatsapp-messages',
    );
    if (!isLogWhatsappMessagesEnabled) {
      return;
    }

    let lastUserCommentAt = conversation.lastUserComment?.createdAt;
    let currentTime = new Date();
    let secondsSinceLastMessage = lastUserCommentAt
      ? (currentTime.getTime() - lastUserCommentAt.getTime()) / 1000
      : null;

    let isTestTemplateFeatureEnabled = this.session.workspace.isFeatureEnabled(
      'whatsapp-test-message-templates',
    );

    this.logService.log({
      event: 'whatsapp_24hr_window_banner_displayed',
      app_id: this.session.workspace.id,
      admin_id: this.session.teammate.id,
      conversation_id: conversation.id,
      user_id: conversation.user?.id,
      phone_number_to_redact: conversation.user?.phone,
      user_phone_country: conversation.user?.phoneCountry,
      conversation_state: conversation.state,
      is_outbound_conversation: conversation.isWhatsappOutboundConversation,
      last_user_comment_at: lastUserCommentAt?.toISOString(),
      current_time: currentTime.toISOString(),
      seconds_since_last_message: secondsSinceLastMessage,
      is_test_template_feature_enabled: isTestTemplateFeatureEnabled,
      channel: conversation.currentChannel,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::WhatsappRestrictedRepliesBanner': typeof WhatsappRestrictedRepliesBanner;
    'inbox2/whatsapp-restricted-replies-banner': typeof WhatsappRestrictedRepliesBanner;
  }
}
